import { BaseRepository } from './baseRepository';
import { DB_CACHE_CONST } from '../../constants/dbCacheConst';

class OrganizationRepository extends BaseRepository {
    constructor() {
        super();
        this.db = DB_CACHE_CONST.STORES.RESOURCES;
        this.table = DB_CACHE_CONST.TABlES.ORGANIZATION;
    }

    getById = async (id) => {
        const data = await this.initData();
        const db = this.taffydb.taffy(data);
        return db({ id }).first();
    };

    change = async (item) => {
        await this.updateDB(item, 'o_id');
    };

    remove = async (item) => {
        await this.removeDB(item, 'o_id');
    };

    getByOCId = async (id) => {
        const data = await this.initData();
        const db = this.taffydb.taffy(data);
        return db({ id });
    };
}

export default new OrganizationRepository();
